import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { withPlaysSelector, withRatingSelector, withUploadDateSelector } from 'common/selectors/settings';
import { Tooltip } from 'react-tooltip';

import {
  MetadataPlays,
  MetadataRating,
  MetadataUploadDate,
} from 'components/video-item/video-item-additional-metadata/fragments';

const Component = connect(
  (state) => ({
    withRating: withRatingSelector(state),
    withPlays: withPlaysSelector(state),
    withUploadDate: withUploadDateSelector(state),
  }),
  false
)(({ video, breakLineBeforeRating, showRating, withRating, withPlays, withUploadDate }) => (
  <div className="ct-video-additional-metadata">
    <div
      className={`ct-video-additional-metadata__list${
        !breakLineBeforeRating ? ' ct-video-additional-metadata__list-wrapped' : ''
      }`}
    >
      {withPlays && <MetadataPlays plays={video.plays} isItem={true} />}

      {withUploadDate && <MetadataUploadDate date={video.displayDate} />}

      {showRating && withRating && !breakLineBeforeRating && (
        <MetadataRating ratingAvg={video.ratingAvg} listElement={true} />
      )}
    </div>

    {showRating && withRating && breakLineBeforeRating && <MetadataRating ratingAvg={video.ratingAvg} />}

    <Tooltip place="top" effect="solid" type="light" className={'tooltip-restyle'} />
  </div>
));

export const VideoItemAdditionalMetadata = ({ video, breakLineBeforeRating, showRating = true }) => (
  <Component video={video} breakLineBeforeRating={breakLineBeforeRating} showRating={showRating} />
);

VideoItemAdditionalMetadata.propTypes = {
  video: PropTypes.object.isRequired,
  breakLineBeforeRating: PropTypes.bool,
  showRating: PropTypes.bool,
};
